import { render } from "./DocumentCard.vue?vue&type=template&id=60bfdb9c&scoped=true&ts=true&lang=pug"
import script from "./DocumentCard.vue?vue&type=script&lang=ts"
export * from "./DocumentCard.vue?vue&type=script&lang=ts"

import "./DocumentCard.vue?vue&type=style&index=0&id=60bfdb9c&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bfdb9c"]])

export default __exports__